import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import CookieConsent from '@/components/CookieConsent';
import ScrollToTop from '@/components/ScrollToTop';
import '@/App.css';

// Pages
import Home from '@/pages/Home';
import About from '@/pages/About';
import Products from '@/pages/Products';
import ProductDetail from '@/pages/ProductDetail';
import Artists from '@/pages/Artists';
import ArtistProfile from '@/pages/ArtistProfile';
import Contact from '@/pages/Contact';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import BuyerDashboard from '@/pages/BuyerDashboard';
import ArtistDashboard from '@/pages/ArtistDashboard';
import AdminDashboard from '@/pages/AdminDashboard';
import Checkout from '@/pages/Checkout';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import BuyerTerms from '@/pages/BuyerTerms';
import BuyerProtection from '@/pages/BuyerProtection';
import DataProtection from '@/pages/DataProtection';
import LegalDisclaimers from '@/pages/LegalDisclaimers';
import ReturnsRefunds from '@/pages/ReturnsRefunds';
import ArtistSupport from '@/pages/ArtistSupport';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <CookieConsent />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:id" element={<ProductDetail />} />
          <Route path="/artists" element={<Artists />} />
          <Route path="/artists/:id" element={<ArtistProfile />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/buyer-dashboard" element={<BuyerDashboard />} />
          <Route path="/artist-dashboard" element={<ArtistDashboard />} />
          <Route path="/admin-dashboard" element={<AdminDashboard />} />
          <Route path="/checkout/:productId" element={<Checkout />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/buyer-terms" element={<BuyerTerms />} />
          <Route path="/buyer-protection" element={<BuyerProtection />} />
          <Route path="/data-protection" element={<DataProtection />} />
          <Route path="/legal-disclaimers" element={<LegalDisclaimers />} />
          <Route path="/returns-refunds" element={<ReturnsRefunds />} />
          <Route path="/artist-support" element={<ArtistSupport />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;